import PropTypes from 'prop-types'

import CustomSelectStatus from '../CustomSelectStatus/CustomSelectStatus'

export default function SelectState({
  isallfilter,
  isfilterleft,
  onChange,
  value,
  label
}) {
  const defaultStatus = [
    'Aprobado',
    'Deshabilitado',
    'Pendiente aprobación'
  ]
  return (
    <CustomSelectStatus
      label={label}
      defaultStatus={defaultStatus}
      selectedStatus={value}
      setSelectedStatus={onChange}
      isallfilter={isallfilter}
      isfilterleft={isfilterleft}
    />
  )
}

SelectState.propTypes = {
  isallfilter: PropTypes.bool,
  isfilterleft: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  label: PropTypes.string
}
SelectState.defaultProps = {
  label: 'Estado',
  value: [],
  onChange: x => x
}
